import React from 'react'
import {MenuItem} from './MenuItem'
import {useAuth} from 'context/AuthProvider'
import {IMenu} from 'models/CMS'
// import {MenuInnerWithSub} from './MenuInnerWithSub'
// import {MegaMenu} from './MegaMenu'
// import {useIntl} from 'react-intl'

export function MenuInner() {
 //  const intl = useIntl()
 const {userData} = useAuth()
 return (
  <>
   {userData?.menu?.map((items: IMenu, index) => (
    <MenuItem
     key={index}
     title={items.Label}
     to={items?.Url}
    />
   ))}
  </>
 )
}
